export default __webpack_public_path__ + "static/media/fauna-runas-prd.653666c5.pdf";